/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_No_DebtsInputs */

const vi_customer_no_debts = /** @type {(inputs: Customer_No_DebtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có công nợ`)
};

/**

* @param {Customer_No_DebtsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_no_debts = /** @type {((inputs?: Customer_No_DebtsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_No_DebtsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_no_debts(inputs)
});